import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@pg-env/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchReferralService {
  api: string;

  constructor(private http: HttpClient) {
    this.api = environment.customerApiUrl;
  }

  /**
   * @method getTableData
   * @description get data for the search result table
   */
  public getReferrals(searchText: any): Observable<any> {
    return this.http.post(`${this.api}/customer/search-lead`, searchText);
  }
}
